import { stubTrue } from 'lodash-es';
import { checkIban } from '../../api/checkIban';
import createAsyncValidator from '../../core/createAsyncValidator';

const ibanValidation = (shouldValidate = stubTrue) =>
  createAsyncValidator((value) => {
    if (shouldValidate(value)) {
      return checkIban(value);
    }
    return {};
  });

export default ibanValidation;
